export default "__VITE_ASSET__133eef21__"